/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformFromJSON, FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformToJSON, } from './FtlSharedGeneratedApiFtlDomainEnumsReleasePlatform';
/**
 * Check if a given object implements the FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultRelease interface.
 */
export function instanceOfFtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultRelease(value) {
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('UpdatedAt' in value) || value['UpdatedAt'] === undefined)
        return false;
    if (!('Platform' in value) || value['Platform'] === undefined)
        return false;
    if (!('BuildNumber' in value) || value['BuildNumber'] === undefined)
        return false;
    if (!('BuildVersion' in value) || value['BuildVersion'] === undefined)
        return false;
    if (!('BuildSemanticVersion' in value) || value['BuildSemanticVersion'] === undefined)
        return false;
    if (!('CommitHash' in value) || value['CommitHash'] === undefined)
        return false;
    return true;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseFromJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'CreatedAt': (new Date(json['createdAt'])),
        'UpdatedAt': (new Date(json['updatedAt'])),
        'Platform': FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformFromJSON(json['platform']),
        'BuildNumber': json['buildNumber'],
        'BuildVersion': json['buildVersion'],
        'BuildSemanticVersion': json['buildSemanticVersion'],
        'CommitHash': json['commitHash'],
    };
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseToJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseToJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultReleaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdAt': ((value['CreatedAt']).toISOString()),
        'updatedAt': ((value['UpdatedAt']).toISOString()),
        'platform': FtlSharedGeneratedApiFtlDomainEnumsReleasePlatformToJSON(value['Platform']),
        'buildNumber': value['BuildNumber'],
        'buildVersion': value['BuildVersion'],
        'buildSemanticVersion': value['BuildSemanticVersion'],
        'commitHash': value['CommitHash'],
    };
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultRelease.js.map